import React from 'react';
import { View } from 'react-native';
import { translate } from '../../../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import CopyToClipboardInput from '../../../components/CopyToClipboardInput';
import BasicModal from '../../../components/BasicModal';
import FontWeight from '../../../styles/font-weights';

interface ModalProps {
    cameraPassword: string;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function PasswordModal({ cameraPassword, isModalVisible, setIsModalVisible }: ModalProps) {
    const { styles } = useStyles(styleSheet);

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setIsModalVisible}
            title={translate('getCameraPassword')}
            width='small'
            mobileHeight='fit'
            cancelButton={{
                customText: translate('close'),
            }}
        >
            <View style={{ rowGap: 8 }}>
                <MyAppText style={styles.description}>{translate('passwordInformation')}</MyAppText>
                <CopyToClipboardInput label={translate('password')} value={cameraPassword} />
            </View>
        </BasicModal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    description: {
        color: theme.colors.neutral[400],
        fontWeight: FontWeight.medium,
        fontSize: 16,
    },
    informationRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}));
